import AllContents from './AllContents';
import React, {useRef, useEffect} from 'react';
import HolderWrapper from './HolderWrapper';
import * as ResponsiveFns from '../utilities/ResponsiveFns';
import * as BaseItems from '../utilities/BaseItems';
import * as StyleFunctions from '../utilities/StyleFunctions';
import * as CoreFns from '../utilities/CoreFns';
import * as ContentsFns from '../ContentsFns';

function App(props) {

  var thisItem = props.thisItem;
  var type = props.type;
  var allStyles = props.allStyles;
  var stylesToAdd = props.stylesToAdd;
  var height = props.height;
  var width = props.width;
  var currentList = props.currentList;
  var internalVariables = props.internalVariables;
  var urlParamsForExecution = props.urlParamsForExecution;
  var urlHeader = props.urlHeader;
  var interactionFn = props.interactionFn;
  var inputValues = props.inputValues;
  var setInputValues = props.setInputValues;
  var itemEdited = props.itemEdited;
  var setItemEdited = props.setItemEdited;
  var editPieces = props.editPieces;
  var clickEditItem = props.clickEditItem;
  var setIsClickingOnContentDiv = props.setIsClickingOnContentDiv;
  var isClickingOnContentDiv = props.isClickingOnContentDiv;
  var upwardInfo = props.upwardInfo;
  var screenSelectionChoices = props.screenSelectionChoices;
  var setScreenSelectionChoices = props.setScreenSelectionChoices;
  var addWhereText = props.addWhereText;
  var potentiallyAddWhichItem = props.potentiallyAddWhichItem;
  var organicChanges = props.organicChanges;
  var userNos = props.userNos;
  var userID = props.userID;
  var hoveringWhere = props.hoveringWhere;
  var actHoveringWhere = props.actHoveringWhere;
  var clickFn = props.clickFn;
  var popUps = props.popUps;
  var setPopUps = props.setPopUps;
  var ownVariables = props.ownVariables;
  var addClassNames = props.addClassNames;
  var addCCColWidth = props.addCCColWidth;
  var draggable = props.draggable;
  var onDrag = props.onDrag;
  var onDragStart = props.onDragStart;
  var onDragEnd = props.onDragEnd;
  var itemInfoPath = props.itemInfoPath;
  var doAScreenRef = props.doAScreenRef;
  var itemInfoPathString = props.itemInfoPathString;
  var flashHighlight = props.flashHighlight;
  var chains = props.chains;
  var lastEdited = props.lastEdited;
  var counter = props.counter;

  const ref1 = useRef();

  useEffect(()=>{
    doAScreenRef(ref1, itemInfoPath);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps




  var cardItems = thisItem.i;
  var sortedCardItemKeys = ResponsiveFns.sortAListBasedOnOrd(cardItems);

  var addCardPiece;


  var gotHeaderForFirst = false;
  var addClassNamesHere = '';
  if (type === 'TABLE' && allStyles.firstRowHeader){
    gotHeaderForFirst = true;
  }

  var stylesToAdd2 = {}


  if (type === 'CARD'){
    stylesToAdd2.wordWrap = 'normal';
  }

  if (type === 'HFLEX'){
    allStyles.height = allStyles.rowHeight;
  }

  function doACardPiece(thisCard, thisCardPath, toAdd, cardPieces, coverWithHeader, index, currentList){
    var stylesToAdd1 = {};
    if (coverWithHeader){
      stylesToAdd1.coverWithHeader = true;
    }
    if (stylesToAdd.coverWithHeader){
      stylesToAdd1.isHeaderCell = true;
    }

    var dragStuff;
    if (!interactionFn){
      if (itemEdited && itemEdited.path.join(' ') === thisCardPath.join(' ')){
        function oDragStart(){
          return function(e){
            itemEdited.d = true;
            setItemEdited({...itemEdited})
          }
        }

        function oDragEnd(e){
          delete itemEdited.d;
          setItemEdited({...itemEdited})
        }

        function oDrag(e){
        }
        dragStuff = {dragStart:oDragStart, onDrag:oDrag, dragEnd:oDragEnd};
      }
    }

    var x = <AllContents userID={userID} chains={chains} key={cardPieces.length} height={height} width={width} currentList={currentList} internalVariables={internalVariables} interactionFn={interactionFn} inputValues={inputValues} setInputValues={setInputValues} itemEdited={itemEdited} setItemEdited={setItemEdited} thisItem={thisCard} itemInfoPath={thisCardPath} stylesToAdd={{...stylesToAdd1, ...stylesToAdd2}} editPieces={editPieces} needToShowError={true} clickEditItem={clickEditItem} addClassNames={addClassNamesHere} dragStuff={dragStuff} parentalType={type} setIsClickingOnContentDiv={setIsClickingOnContentDiv} isClickingOnContentDiv={isClickingOnContentDiv} upwardInfo={upwardInfo.concat(toAdd)} addWhereText={addWhereText} potentiallyAddWhichItem={potentiallyAddWhichItem} organicChanges={organicChanges} userNos={userNos} hoveringWhere={hoveringWhere} actHoveringWhere={actHoveringWhere} screenSelectionChoices={screenSelectionChoices} setScreenSelectionChoices={setScreenSelectionChoices} popUps={popUps} setPopUps={setPopUps} ownVariables={ownVariables} doAScreenRef={doAScreenRef} flashHighlight={flashHighlight} urlParamsForExecution={urlParamsForExecution} urlHeader={urlHeader} lastEdited={lastEdited} counter={counter}/>
    cardPieces.push(x);
  }

  var cardPieces = ContentsFns.getCardItems(sortedCardItemKeys, itemInfoPath, cardItems, currentList, internalVariables, width, height, upwardInfo, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains, interactionFn, doACardPiece, gotHeaderForFirst);


  if (!interactionFn){
    if (addClassNames.indexOf(' editing') > -1 && addWhereText){
      if (potentiallyAddWhichItem){
        if (type === 'CONTAINER'){
          addCardPiece = <div className='row dropSpace'><div className='col-12'><center>+ Row</center></div></div>
//
        }else{

          if (potentiallyAddWhichItem.t === 'BUTTON' || potentiallyAddWhichItem.t === 'INPUT' || potentiallyAddWhichItem.t === 'TIMER' || potentiallyAddWhichItem.t === 'GALLERY' || potentiallyAddWhichItem.t === 'TABLE' || potentiallyAddWhichItem.t === 'VIDEO' || potentiallyAddWhichItem.t === 'ICON' || potentiallyAddWhichItem.t === 'LINECHART' || potentiallyAddWhichItem.t === 'SUMMARY' || potentiallyAddWhichItem.t === 'IMG'){
            var base = BaseItems.getBaseConstruct(potentiallyAddWhichItem.t, 1);
            if (ResponsiveFns.is12Width(potentiallyAddWhichItem.t)){
              base.s.colWidth = {t:'bsu', v:12};
            }
            var currentListTemp = JSON.parse(JSON.stringify(currentList));
            var baseSet = CoreFns.goDownPath(currentListTemp, itemInfoPath.concat(['i']));
            baseSet.base = base;
            
            var gotHeaderForFirst2 = false; // no need to invoke unless its table
            var cardPieces1 = ContentsFns.getCardItems(['base'], itemInfoPath, {base}, currentListTemp, internalVariables, width, height, upwardInfo, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains, interactionFn, doACardPiece, gotHeaderForFirst2);
            addCardPiece = cardPieces1[0];


          }else{
             var tt = <p className='card-text'><center>+ {CoreFns.getElementInfo(potentiallyAddWhichItem.t).t}</center></p>
  //        
            if (type === 'CARD'){
              addCardPiece =  <div className='card-body dropSpace' >{tt}</div>
    //
            }else if (type === 'HFLEX'){
              var colWidthToAdd = '3';
              if (ResponsiveFns.is12Width(potentiallyAddWhichItem.t)){
                colWidthToAdd = '12';
              }
              addCardPiece =  <div className={'col-' + colWidthToAdd + ' dropSpace'} >{tt}</div>
    //
            }else if (type === 'TD' ){
              addCardPiece =  <div className='dropSpace' >{tt}</div>
    //          
    //
            }else if (type === 'TABLE'){
              addCardPiece = <tr><td>{tt}</td></tr>
            }else if (type === 'TR'){
              addCardPiece = <td>{tt}</td>
            }else if (type === 'TABITEM'){
              addCardPiece = <div>{tt}</div>
            }else{
              console.warn(type);
            }

          }

  //
        }         
      }else{
        if (type === 'CONTAINER'){
          addCardPiece =  <div className='emptySpace' ><p className='card-text'><center>Empty Container</center></p></div>
//
        }

      }

    }else if (sortedCardItemKeys.length === 0){

      if (type === 'CARD'){
        addCardPiece =  <div className='card-body emptySpace' >
          <p className='card-text'>Empty Card</p>
        </div>

      }else if (type === 'HFLEX'){
        addCardPiece =  <div className='col-12 emptySpace' >
          <p className='card-text'><center>Empty Row</center></p>
        </div>
      }else if (type === 'CONTAINER'){
        addCardPiece =  <div className='emptySpace' ><p className='card-text'><center>Empty Container</center></p></div>
      }else if (type === 'TABS'){
        addCardPiece =  <div className='emptySpace' ><p className='card-text'>Empty Set of Tabs</p></div>
      }else if (type === 'TABITEM'){
        addCardPiece =  <div className='emptySpace' ><p className='card-text'>Empty Tab</p></div>
      }else if (type === 'TABLE'){
        addCardPiece = <tr><td><p className='card-text'>Empty Table</p></td></tr>
//
      }else if (type === 'TR'){
        addCardPiece =  <td><p className='card-text'>Empty Row</p></td>
      }else if (type === 'TD'){
        addCardPiece =  <div className='emptySpace'><p className='card-text'>Empty Cell</p></div>
      }else if (type === 'RADIO'){
        addCardPiece =  <div className='emptySpace'><p className='card-text'>Empty Set of Choices</p></div>
//
      }else{
        console.warn(type);
      }
    }
  } 

  var className3;
  var cc = {...stylesToAdd, ...allStyles};
  var ins;
  if (type === 'CARD' || type === 'HFLEX' || type === 'CONTAINER' || type === 'TABITEM'){
    if (type === 'CARD'){
      className3 = StyleFunctions.iterateClassNames('card' + addClassNames, [], allStyles);
    }else if (type === 'HFLEX'){
      className3 = StyleFunctions.iterateClassNames('row' + addClassNames + addCCColWidth, ['noGutter', 'justifyContent', 'alignItems'], allStyles);

      StyleFunctions.sortOutBackgroundColor(cc, thisItem.s, itemInfoPath, currentList, internalVariables, width, height, upwardInfo, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains, false);

    }else if (type === 'CONTAINER' || type === 'TABITEM'){
      className3 = StyleFunctions.iterateClassNames((allStyles.styled ? 'container-fluid' : '') + addClassNames , [], allStyles);
      if (type === 'CONTAINER'){
        StyleFunctions.sortOutBackgroundColor(cc, thisItem.s, itemInfoPath, currentList, internalVariables, width, height, upwardInfo, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains, false);
      }
    } 

    ins = <HolderWrapper className3={className3} type={type} itemEdited={itemEdited} cc={cc} cardPieces={cardPieces} addCardPiece={addCardPiece} sortedCardItemKeys={sortedCardItemKeys} itemInfoPath={itemInfoPath} organicChanges={organicChanges} currentList={currentList} width={width} setItemEdited={setItemEdited}/>    
//
//
  }else if (type === 'TABLE'){
    var th = null;
    var tbody = null;
    if (allStyles.firstRowHeader){
      if (cardPieces.length > 0){

        var c1 = ContentsFns.getCardItems([sortedCardItemKeys[0]], itemInfoPath, cardItems, currentList, internalVariables, width, height, upwardInfo, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains, interactionFn, doACardPiece, gotHeaderForFirst);

        th = <th>{c1}</th>
//

        tbody = cardPieces.filter((aCardP, index)=>{return +index >= c1.length});
      }
    }else{
      tbody = cardPieces;
    }
    className3 = StyleFunctions.iterateClassNames('table' + addClassNames , ['tableHover', 'tableStriped', 'tableBordered', 'tableDark'], allStyles);
   ins = <table className={className3} style={cc}>{th}<tbody>{tbody}{addCardPiece}</tbody></table>
  }else if (type === 'TR'){
   return <tr ref={ref1} style={cc} className={addCCColWidth} onClick={clickFn} onMouseOver={actHoveringWhere(itemInfoPathString)} onMouseOut={actHoveringWhere('')}>{cardPieces}{addCardPiece}</tr>
//
  }else if (type === 'TD'){
    if (cc.isHeaderCell){
       return <th ref={ref1} style={cc} className={addCCColWidth} scope='col' onClick={clickFn} onMouseOver={actHoveringWhere(itemInfoPathString)} onMouseOut={actHoveringWhere('')}>{cardPieces}{addCardPiece}</th>
//
    }else{
     return <td ref={ref1} style={cc} className={addCCColWidth} onClick={clickFn} onMouseOver={actHoveringWhere(itemInfoPathString)} onMouseOut={actHoveringWhere('')}>{cardPieces}{addCardPiece}</td>

    }
//
//
  }else{
    console.warn(type);
  }

  return <div ref={ref1} className={addCCColWidth} onClick={clickFn} draggable={draggable} onDragStart={onDragStart} onDrag={onDrag} onDragEnd={onDragEnd} onMouseOver={actHoveringWhere(itemInfoPathString)} onMouseOut={actHoveringWhere('')}>{ins}</div>
//

}
//




export default App;
